import { Check, Info } from "lucide-react";
import { PRODUCTS } from "@/data/products";
import { DuckBadge } from "@/components/DuckMascot";

const BADGE_STYLES = {
  "DuckTheBugs Pick": "bg-forest text-cream",
  "Best budget option": "bg-duckgreen/20 text-forest",
  "Best for Large Yards": "bg-terracotta text-white",
};

// Editorial product recommendation card — deliberately NOT an e-commerce tile.
export default function ProductRecommendation({ slug }) {
  const p = PRODUCTS[slug];
  if (!p) return null;
  const badgeCls = BADGE_STYLES[p.badge] || "bg-pill text-forest";
  const isPick = p.badge === "DuckTheBugs Pick";

  return (
    <div
      className="relative flex flex-col h-full rounded-3xl border border-forest/10 bg-card p-6 hover:shadow-lg hover:shadow-forest/5 transition-shadow"
      data-testid={`product-${slug}`}
    >
      <div className="flex items-center justify-between mb-4">
        <span className={`px-3 py-1 rounded-full text-[11px] font-mono font-medium ${badgeCls}`}>
          {p.badge}
        </span>
        <span className="font-mono text-sm text-forest-950/50" title="Indicative price range">
          {p.priceRange}
        </span>
      </div>

      {isPick && (
        <div className="absolute -top-3 -right-3">
          <DuckBadge size={40} />
        </div>
      )}

      <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-forest-950/40">{p.category}</span>
      <h3 className="mt-1 font-serif text-lg font-bold text-forest-950">{p.name}</h3>

      <div className="mt-4 space-y-3 flex-1">
        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.15em] text-duckgreen mb-1.5">What we like</p>
          <ul className="space-y-1.5">
            {p.whatWeLike.map((w, i) => (
              <li key={i} className="flex items-start gap-2 text-sm text-forest-950/75">
                <Check className="w-3.5 h-3.5 text-duckgreen mt-1 shrink-0" />
                {w}
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.15em] text-terracotta mb-1.5">What to know</p>
          <ul className="space-y-1.5">
            {p.whatToKnow.map((w, i) => (
              <li key={i} className="flex items-start gap-2 text-sm text-forest-950/75">
                <Info className="w-3.5 h-3.5 text-terracotta mt-1 shrink-0" />
                {w}
              </li>
            ))}
          </ul>
        </div>
      </div>

      {p.kidsPetsNote && (
        <div className="mt-4 pt-4 border-t border-forest/10">
          <p className="text-xs text-teal leading-relaxed">
            <span className="font-semibold">Kids & pets:</span> {p.kidsPetsNote}
          </p>
        </div>
      )}
    </div>
  );
}
